document.addEventListener('DOMContentLoaded', () => {
    setTimeout(() => {
        LoadingComp.remove();
    }, 500);
});

class LoadingComp {
    /**
     * Remove the loading overlay from the DOM.
     * If the overlay doesn't exist, the function does nothing.
     * The removal is done after a fade-out transition.
     *
     * @static
     * @public
     */
    static remove() {
        const overlay = document.querySelector('.loading-overlay');
        if (!overlay) {
            return;
        }

        // Ensure transition exists even if CSS was modified
        overlay.style.transition = 'opacity 0.4s ease';

        // Trigger fade-out
        requestAnimationFrame(() => {
            overlay.style.opacity = '0';
        });

        // Remove from DOM after transition
        overlay.addEventListener('transitionend', () => {
            overlay.remove();
        }, { once: true });
    }
}
